import { render, staticRenderFns } from "./PagoCUP.vue?vue&type=template&id=d60fb1fa&"
import script from "./PagoCUP.vue?vue&type=script&lang=js&"
export * from "./PagoCUP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports